import propTypes from 'prop-types';
import React from 'react';

const Icon = props => {
	const styles = {
		svg: {
			display: 'inline-block',
			verticalAlign: 'middle'
		},
		path: {
			fill: props.color
		}
	};

	return (
		<svg
			style={styles.svg}
			width={`${props.size}px`}
			height={`${props.size}px`}
			viewBox='0 0 20 20'
		>
			<path
				style={styles.path}
				d={props.icon}
			/>
		</svg>
	);
};

Icon.propTypes = {
	icon: propTypes.string.isRequired,
	size: propTypes.number,
	color: propTypes.string
};

Icon.defaultProps = {
	size: 16
};

export default Icon;



// WEBPACK FOOTER //
// components/icon.js